import React from 'react';
import TextBox from 'devextreme-react/text-box';
import NumberBox from 'devextreme-react/number-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator, { RequiredRule } from 'devextreme-react/validator';
import Button from 'devextreme-react/button';
import CheckBox from 'devextreme-react/check-box';
import './login-form2.scss';
import appInfo from '../../app-info';
import { Link } from 'react-router-dom';

export default class LoginForm2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      login: '',
      password: '',
    };
  }

  render() {
    const { login, password } = this.state;
    return (


    <div className={'esref-full-screen'}>
      <ValidationGroup className={'login-header'}>
        <div className={'login-header'}>
          <div className={'title'}>{'Teşvik Master'}</div>
          <div className={'login-text'}>Giriş yapınız</div>
        </div>
        <div className={'dx-field'}>
          <TextBox
            value={login}
            onValueChanged={this.loginChanged}
            placeholder={'Kullanıcı adı'}
            width={'100%'}
          >
            <Validator>
              <RequiredRule message={'Kullanıcı adı boş olamaz'} />
            </Validator>
          </TextBox>
        </div>
        <div className={'dx-field'}>
          <TextBox
            mode={'password'}
            value={password}
            onValueChanged={this.passwordChanged}
            placeholder={'Password'}
            width={'100%'}
          >
            <Validator>
              <RequiredRule message={'Şifre boş olamaz.'} />
            </Validator>
          </TextBox>
        </div> 
        <div className={'dx-field'}>
          <Button
            type={'default'}
            text={'Giriş'}
            onClick={this.onLoginClick}
            width={'100%'}
          />
        </div> 
      </ValidationGroup>
      </div>
    );
  }

    // eslint-disable-next-line no-undef
  loginChanged = e => {
    this.setState({ login: e.value });
  };

    // eslint-disable-next-line no-undef
  passwordChanged = e => {
    this.setState({ password: e.value });
  };

    // eslint-disable-next-line no-undef

    // eslint-disable-next-line no-undef
  onLoginClick = args => {
    if (!args.validationGroup.validate().isValid) {
      return;
    }

    const { login, password } = this.state;
    this.props.onLoginClick(login, password);

    args.validationGroup.reset();
  };
}
